export default __webpack_public_path__ + "static/media/3056.9ba00781.jpg";